import { includes, pick, result, values, isEmpty } from 'libraries/lodash'
import { toast } from 'react-toastify'
import CheckIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import { pushUrl } from 'front-end-core/core/history'
import getUrl from 'front-end-core/core/url'
import  { map } from 'rxjs/operators'

import { PRECEDENTS_CONTENT } from 'constants/controllers'
import {
  SET_PRECEDENTS_CONTENT_ENTER_IF_EMPTY,
  SET_PRECEDENTS_EXPANDED_SECTION,
  SET_PRECEDENT_ADMIN_IS_UPDATE_MODE,
  SET_PRECEDENT_ID,
  SET_PRECEDENT_SECTION_ID,
  SET_PRECEDENT_ADMIN_FILES,
  SET_PRECEDENT_ADMIN_FILE_SELECTED,
  SET_PRECEDENT_ADMIN_FILE_NAME,
  SET_PRECEDENT_ADMIN_PARENTS,
  SET_PRECEDENT_ADMIN_PARENT_ID,
  SET_PRECEDENT_ADMIN_POSITION,
  SET_PRECEDENT_ADMIN_FILE_DESCRIPTION,
  SET_PRECEDENT_ADMIN_TITLE,
  SET_PRECEDENT_ADMIN_TIERS,
  SET_PRECEDENT_ADMIN_CHECKBOXES,
  SET_PRECEDENT_ADMIN_PLACE_AT,
  SET_PRECEDENTS_VIEW,
  SET_PRECEDENT_TILED_MENU
} from './types'
import { refreshPrecedents, submitPrecedent } from 'services/PrecedentsService'
import notificationToast from 'helpers/notificationToast'
import { PrecedentsCheckbox, TiledMenu } from 'interfaces/precedents'
import { AppDispatch, RootState } from 'redux/store';

export const precedentsContentSetEnterIfEmpty = (enterIfEmpty: boolean) => ({
  type: SET_PRECEDENTS_CONTENT_ENTER_IF_EMPTY,
  enterIfEmpty
})

export const setPrecedentsView = (view: string) => ({
  type: SET_PRECEDENTS_VIEW,
  view
})

export const setPrecedentId = (precedentId: string) => ({
  type: SET_PRECEDENT_ID,
  precedentId
})

export const setPrecedentSectionId = (sectionId: string) => ({
  type: SET_PRECEDENT_SECTION_ID,
  sectionId
})

export const setPrecedentsExpandedSection = (expandedSection: any) => ({
  type: SET_PRECEDENTS_EXPANDED_SECTION,
  expandedSection
})

export const setPrecedentAdminIsUpdateMode = (isUpdateMode: boolean) => ({
  type: SET_PRECEDENT_ADMIN_IS_UPDATE_MODE,
  isUpdateMode
})

export const setPrecedentAdminFiles = (files: any) => ({
  type: SET_PRECEDENT_ADMIN_FILES,
  files
})

export const setPrecedentAdminFileSelected = (fileSelected: boolean) => ({
  type: SET_PRECEDENT_ADMIN_FILE_SELECTED,
  fileSelected
})

export const setPrecedentAdminFileName = (fileName: string) => ({
  type: SET_PRECEDENT_ADMIN_FILE_NAME,
  fileName
})

export const setPrecedentAdminFileDescription = (description:string) => ({
  type: SET_PRECEDENT_ADMIN_FILE_DESCRIPTION,
  description
})

export const setPrecedentAdminTitle = (title: string) => ({
  type: SET_PRECEDENT_ADMIN_TITLE,
  title
})

export const setPrecedentAdminParents = (parents: any) => ({
  type: SET_PRECEDENT_ADMIN_PARENTS,
  parents
})

export const setPrecedentAdminParentId = (parentId:string) => ({
  type: SET_PRECEDENT_ADMIN_PARENT_ID,
  parentId
})

export const setPrecedentAdminPosition = (position: string) => ({
  type: SET_PRECEDENT_ADMIN_POSITION,
  position
})

export const setPrecedentAdminTiers = (tiers: any[]) => ({
  type: SET_PRECEDENT_ADMIN_TIERS,
  tiers
})

export const setPrecedentAdminCheckboxes = (checkBoxes: PrecedentsCheckbox[]) => ({
  type: SET_PRECEDENT_ADMIN_CHECKBOXES,
  checkBoxes
})

export const setPrecedentsAdminPlaceAt = (placeAt: any) => ({
  type: SET_PRECEDENT_ADMIN_PLACE_AT,
  placeAt
})

export const resetPrecedentAdminState = () => {
  return (dispatch: AppDispatch, _:any) => {
    dispatch(setPrecedentAdminIsUpdateMode(null))
    dispatch(setPrecedentAdminFileName(null))
    dispatch(setPrecedentAdminFileSelected(null))
    dispatch(setPrecedentAdminTitle(''))
    dispatch(setPrecedentAdminFileDescription(''))
    dispatch(setPrecedentAdminParentId(null))
    dispatch(setPrecedentAdminPosition(''))
    dispatch(setPrecedentAdminTiers([]))
    dispatch(setPrecedentAdminCheckboxes([
      { value: 'lite', checked: false, label: 'FC Core' },
      { value: 'premium', checked: false, label: 'FC Premium' },
      { value: 'clarilis', checked: false, label: 'Clarilis Joint Venture' },
      { value: 'clarilis-shares', checked: false, label: 'Clarilis Shares' }
    ]))
    dispatch(setPrecedentsAdminPlaceAt(null))
    dispatch(setPrecedentAdminParents(null))
  }
}

export const updatePrecedentAdminState = () => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const { expandedSection, precedentId, admin: { files } } = getState().precedents
    const isUpdateMode = precedentId && precedentId !== 'new' && files && Object.prototype.hasOwnProperty.call(files, precedentId)
    const file = files[precedentId]
    const fileName = (isUpdateMode && file.name) || null
    const title = (isUpdateMode && file.title) || ''
    const description = (isUpdateMode && file.description) || ''
    const parentId = (isUpdateMode && file.parentId) || expandedSection || ''
    const position = (isUpdateMode && file.position) || null
    const tiers = (isUpdateMode && file.tiers) || []
    const checkBoxes = [
      { value: 'lite', checked: (!isEmpty(tiers) && includes(tiers, 'lite')), label: 'FC Core' },
      { value: 'premium', checked: (!isEmpty(tiers) && includes(tiers, 'premium')), label: 'FC Premium' },
      { value: 'clarilis', checked: (!isEmpty(tiers) && includes(tiers, 'clarilis')), label: 'Clarilis M&A' },
      { value: 'clarilis-shares', checked: (!isEmpty(tiers) && includes(tiers, 'clarilis-shares')), label: 'Clarilis Shares' }
    ]

    const placeAt = isUpdateMode ? null : 'bottom'

    dispatch(setPrecedentAdminIsUpdateMode(isUpdateMode))
    dispatch(setPrecedentAdminFileName(fileName))
    dispatch(setPrecedentAdminFileSelected(null))
    dispatch(setPrecedentAdminTitle(title))
    dispatch(setPrecedentAdminFileDescription(description))
    dispatch(setPrecedentAdminParentId(parentId))
    dispatch(setPrecedentAdminPosition(position))
    dispatch(setPrecedentAdminTiers(tiers))
    dispatch(setPrecedentAdminCheckboxes(checkBoxes))
    dispatch(setPrecedentsAdminPlaceAt(placeAt))
  }
}

const calculatePosition = (pickedFiles: {position: number}[], direction: string) => {
  if (direction === 'bottom') {
    const largestPosition = values(pickedFiles).reduce((prev, next) => {
      return next.position > prev ? next.position : prev
    }, 0)
    return largestPosition + 1
  } else if (direction === 'top') {
    const smallestPosition = values(pickedFiles).reduce((prev, next) => {
      return next.position < prev ? next.position : prev
    }, 0)
    return smallestPosition - 1
  }
}

export const submitPrecedentAdminForm = () => {
  return (_dispatch: AppDispatch, getState: () => RootState) => {
    const {
      aol: { name: aol },
      precedents: {
        precedentId,
        sectionId,
        view,
        admin: {
          isUpdateMode,
          parents,
          files,
          parentId,
          title,
          description,
          fileSelected,
          fileName,
          checkBoxes,
          position,
          placeAt
        }
      }
    } = getState()

    const filesInSection = result(parents, parentId, [])
    const pickedFiles = pick(files, filesInSection)

    // If file attached, show uploading notification
    if (fileSelected) {
      notificationToast(<InfoIcon />, toast.TYPE.INFO, 'Uploading files!')
    }

    const payload = {
      documentId: precedentId !== 'new' && precedentId,
      parentId,
      description,
      file: fileSelected,
      title,
      name: fileName,
      tiers: checkBoxes,
      library: view === 'browse' ? 'precedents' : view,
      position: isUpdateMode ? position : calculatePosition(pickedFiles as any, placeAt)
    }

    submitPrecedent(payload, aol).pipe(
      map((data:string) => JSON.parse(data))
    )
    .subscribe(
      (res:any) => {
        if (res.success) {
          notificationToast(<CheckIcon /> as any, toast.TYPE.SUCCESS, 'Success!')
          refreshPrecedents(aol)
            .subscribe(() => {
              // Redirect to edit page.
              // this.props.precedentId === 'new' &&
              pushUrl(getUrl(PRECEDENTS_CONTENT, {
                aol,
                view,
                sectionId,
                expanded: res.documentId || parentId
              }))
            })
        } else {
          notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Error', 'bg-indian-red white')
        }
      }
    )
  }
}

export const setPrecedentsTiledMenu = (tiledMenu: TiledMenu) => ({
  type: SET_PRECEDENT_TILED_MENU,
  tiledMenu
})
